import { IFormatAlert } from "../IFormatAlert";
import { IFormatObjectEditable } from "../IFormatObjectEditable";

export abstract class AbstractFormatAlert implements IFormatAlert {
  constructor(public isError: boolean) {
  }
  abstract get detectedObject(): IFormatObjectEditable;
  abstract get kind(): string;
  abstract get target(): string;
  abstract get description(): string;
}
